import React from 'react'
import Activity from '../../pages-partial/StudentActivity'

const StudentActivity = () => {
  return (
    <div><Activity /></div>
  )
}

export default StudentActivity